var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarchart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    focusable: "false",
    fill: "currentColor",
    style: {
      userSelect: "none",
      width: "100%",
      height: "100%",
      display: "inline-block",
      flexShrink: 0
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    weight: "duotone"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208,40V208H152V40Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,200h-8V40a8,8,0,0,0-8-8H152a8,8,0,0,0-8,8V80H96a8,8,0,0,0-8,8v40H48a8,8,0,0,0-8,8v64H32a8,8,0,0,0,0,16H224a8,8,0,0,0,0-16ZM160,48h40V200H160ZM104,96h40V200H104ZM56,144H88v56H56Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarchart);
export default __webpack_public_path__ + "static/media/barchart.73b30cadd3823c1b150ced88da433500.svg";
export { ForwardRef as ReactComponent };